// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chevron-solid';

export const Component = () => (
  <path d='m18.63 19.71 5.891-7.855L18.631 4H0l4.885 7.855L0 19.709h18.63Z' />
);

export const viewBox = '0 0 25 25';
